/* Лист «Сортировка и фильтры» для React-страниц (студия): та же разметка, что у листа разделов на движках (ui/filter-sheet.ts) */
import { Sheet } from './Sheet';
import { filterClick, filterSheetInner, type FilterGroup, type FilterTexts } from './filter-sheet';

export function FilterSheet({
  id,
  open,
  groups,
  texts,
  onChange,
  onClose,
}: {
  id: string;
  open: boolean;
  groups: FilterGroup[];
  texts: FilterTexts;
  /** выбор группы key сменился: применить сразу (лист остаётся открытым) */
  onChange(key: string, value: string[]): void;
  onClose(): void;
}) {
  return (
    <Sheet id={id} label={texts.title} open={open} onClose={onClose}>
      <div
        className="cbody fs-sh"
        onClick={event => {
          if (event.target instanceof Element && event.target.closest('[data-bsheet-x]')) {
            onClose();
            return;
          }
          filterClick(event.target, groups).forEach(change => onChange(change.key, change.value));
        }}
        dangerouslySetInnerHTML={{ __html: filterSheetInner(groups, texts) }}
      />
    </Sheet>
  );
}
